import React from 'react';
import { Box, Typography } from '@mui/material';

export interface InsightCardProps {
  icon: string;
  title: string;
  name: string;
  value: string | number;
  sublabel?: string;
  color?: 'primary' | 'secondary' | 'success' | 'error' | 'warning' | 'info';
  onClick?: () => void;
}

export const InsightCard: React.FC<InsightCardProps> = ({
  icon,
  title,
  name,
  value,
  sublabel,
  color = 'primary',
  onClick,
}) => {
  return (
    <Box
      sx={{
        p: 2,
        bgcolor: `${color}.50`,
        borderRadius: 1,
        border: 1,
        borderColor: `${color}.main`,
        cursor: onClick ? 'pointer' : 'default',
        transition: 'transform 0.2s',
        '&:hover': onClick ? { transform: 'scale(1.02)' } : {},
      }}
      onClick={onClick}
    >
      <Typography
        variant="subtitle2"
        sx={{ fontWeight: 600, color: `${color}.dark`, mb: 1 }}
      >
        {icon} {title}
      </Typography>
      <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
        {name}
      </Typography>
      <Typography variant="h6" sx={{ color: `${color}.dark`, mt: 0.5 }}>
        {value}
      </Typography>
      {sublabel && (
        <Typography variant="caption" color="text.secondary">
          {sublabel}
        </Typography>
      )}
    </Box>
  );
};

export default InsightCard;

